import React, { useState } from 'react'
import raj from '../../../assets/raj.jpeg'
import { useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

const MyClosedProjects = ({ endpoint, checkprojexists })  =>{

    const [closedprojects, setClosedProjects] = useState([]);

    useEffect(() => {
        const fetchClosedProjects = async(endpointfunc) => {
            try {
                const response = await fetch(`${API_URL}${endpointfunc}`);
                const data = await response.json();
                setClosedProjects(data);
                if (data.length > 0){
                    checkprojexists('exists');
                }
                else {
                    checkprojexists(null);
                }
            } catch (error) {
                console.error('Error fetching projects:', error);
            }
        };
        fetchClosedProjects(endpoint);
        console.log(closedprojects);
    }, [endpoint])

    return (
        <div>
            {closedprojects.length > 0 ? (
                closedprojects.map(project => (
                    <div className='myprojsresult-container' key={project.id}>
                        {/* <div className='myprojsresult-grid-1'>
                            <a href=""><span>{project.ProjectID}</span></a>
                        </div> */}
                        <div className='myprojsresult-grid-2'>
                            <a href={`/project/${project.project_id}`}><span style={{fontWeight:'400'}}>{project.title}</span></a>
                        </div>
                        <div className='myprojsresult-grid-3'>
                            <span>{project.role}</span>
                        </div>
                        {/* <div className='myprojsresult-grid-4'>
                            <img src={raj} className='userimg' alt={project.owner}></img>
                            <span style={{ marginTop: '0.7rem' }}>{project.OwnerName}</span>
                        </div> */}
                        <div className='myprojsresult-grid-5'>
                            <span className={`recstatus ${project.recruiting === 'Open' ? 'recopen' : 'recclosed'}`}>{project.recruiting}</span>
                        </div>
                        <div className='myprojsresult-grid-6'>

                            <span className={`phasestatus ${project.phase === 'Onboarding' ? 'phaseonboarding' :
                                project.phase === 'Initiation' ? 'phaseinitiation' :
                                    project.phase === 'Execution' ? 'phaseexecution' :
                                        project.phase === 'Closed' ? 'phaseclosed' :
                                            ''
                                }`}>{project.phase}</span>
                        </div>
                        <div className='myprojsresult-grid-7'>
                            <span>{project.creation_date}</span>
                        </div>
                        <div className='myprojsresult-grid-8'>
                            <span>{project.last_active}</span>
                        </div>
                    </div>
                ))
            ) : (
                <p style={{ textAlign: 'center', marginTop:'0.5rem', paddingBottom:'1rem' }}>No projects found.</p>
            )}
        </div>
    )
}

export default MyClosedProjects;